/* Anime-Pass — Drop counter live ticker
   Randomly increments the "claimed" count by 1–2 units every 3–15 s.
   State is held in sessionStorage so navigating between pages keeps
   the number consistent within a browsing session.
   Flashes the "Selling fast" label on each tick as a notification. */
(function () {
  'use strict';

  var STORAGE_KEY = 'ap-drop-claimed';
  var MIN_INTERVAL = 3000;
  var MAX_INTERVAL = 15000;
  var MIN_STEP = 1;
  var MAX_STEP = 2;

  function destroy(meter) {
    if (meter._apTickerTimer) {
      clearTimeout(meter._apTickerTimer);
      meter._apTickerTimer = null;
    }
    meter._apTickerInit = false;
  }

  function init(meter) {
    destroy(meter);
    meter._apTickerInit = true;

    var dropSize = parseInt(meter.getAttribute('data-ap-drop-size'), 10);
    if (!dropSize || dropSize <= 0) return;

    var elClaimed = meter.querySelector('[data-ap-meter-claimed]');
    var elRemaining = meter.querySelector('[data-ap-meter-remaining]');
    var elFill = meter.querySelector('[data-ap-meter-fill]');
    var elHot = meter.querySelector('.hot');
    var section = meter.closest('.shopify-section');
    var elProof = section
      ? section.querySelectorAll('[data-ap-proof-count]')
      : document.querySelectorAll('[data-ap-proof-count]');

    var serverClaimed = elClaimed ? parseInt(elClaimed.textContent, 10) || 0 : 0;

    var stored = null;
    try { stored = sessionStorage.getItem(STORAGE_KEY); } catch (e) {}

    var claimed;
    if (stored !== null) {
      var parsed = JSON.parse(stored);
      if (parsed.dropSize === dropSize && parsed.claimed >= serverClaimed) {
        claimed = parsed.claimed;
      } else {
        claimed = serverClaimed;
      }
    } else {
      claimed = serverClaimed;
    }

    render(claimed, dropSize, false);
    scheduleTick(claimed, dropSize);

    function render(c, total, flash) {
      var remaining = Math.max(total - c, 0);
      var pct = Math.min((c / total) * 100, 100);

      if (elClaimed) elClaimed.textContent = c;
      if (elRemaining) elRemaining.textContent = remaining;
      if (elFill) elFill.style.width = pct + '%';
      elProof.forEach(function (el) { el.textContent = c; });

      if (flash && elHot) {
        elHot.classList.remove('is-flash');
        void elHot.offsetWidth;
        elHot.classList.add('is-flash');
      }
    }

    function save(c, total) {
      try {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
          claimed: c,
          dropSize: total
        }));
      } catch (e) {}
    }

    function scheduleTick(current, total) {
      if (current >= total) return;

      var delay = MIN_INTERVAL + Math.random() * (MAX_INTERVAL - MIN_INTERVAL);

      meter._apTickerTimer = setTimeout(function () {
        if (!meter._apTickerInit) return;

        var step = MIN_STEP + Math.floor(Math.random() * (MAX_STEP - MIN_STEP + 1));
        current = Math.min(current + step, total);

        render(current, total, true);
        save(current, total);
        scheduleTick(current, total);
      }, delay);
    }
  }

  function boot() {
    document.querySelectorAll('[data-ap-meter]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var meter = e.target.querySelector('[data-ap-meter]');
    if (meter) init(meter);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var meter = e.target.querySelector('[data-ap-meter]');
    if (meter) destroy(meter);
  });
})();
